import type { ReactNode } from "react";
import { NotificationProvider } from "@intrasync/react";
import { useResponsive } from "./hooks/useResponsive";
import { toastStackProps } from "./toastPolicy";

/**
 * The library NotificationProvider with the toast stack capped on a phone
 * (see toastPolicy.ts). Must render inside the theme provider, so the
 * breakpoint is the theme's `sm`.
 */
export default function ResponsiveNotificationProvider({ children }: { children: ReactNode }) {
  const { isPhone } = useResponsive();
  return <NotificationProvider {...toastStackProps(isPhone)}>{children}</NotificationProvider>;
}
